module.exports = __webpack_public_path__ + "static/media/cscc_happy-hour.6820f3f5.jpg";